import merge from 'lodash/merge'
import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import { StorageType, useList, useUserTimeZone } from '@ztechapps/common.hook'
import type { Order } from '@ztechapps/common.contract'
import { useMemo } from 'react'
import { orderListQuery } from '../graphql'

export const useOrderList = (props?: Partial<UseListProps>): UseListResult<Order> => {
  //const filterCategory = StorageKeys.orderFilterCategory
  // const { setting } = useAppSetting({ appSettingKey: AppSettingKey.FILTER_CASCADE })
  const timeZone = useUserTimeZone()

  const mergeUseListProps = useMemo(() => {
    //we cannot merge directly the query because lodash will do the infinite loop
    //so we remove it first and assign it later it later

    const defaultProps: UseListProps = {
      query: orderListQuery,
      entity: 'orderList',
      sort: { createdAt: -1 },
      limit: 100,
      options: {
        queryOptions: {
          fetchPolicy: 'cache-and-network', //make it request for network for the list
        },
      },
      listActionOptions: {
        storageType: StorageType.localStorage,
        timeZone,
      },
    }

    const { query: defaultQuery, ...restDefaultProps } = defaultProps
    const { query: propsQuery, ...restProps } = props ?? {}

    let finalProps = merge({}, restDefaultProps, restProps) as UseListProps
    finalProps = {
      ...finalProps,
      query: propsQuery ?? defaultQuery,
    }

    return finalProps
  }, [props, timeZone])

  return useList<Order>(mergeUseListProps)
}
